import React from "react"
import { useIntl } from "react-intl"
import { FormDatePicker } from "@carrotfertility/carotene-core-x"
import { InviteStatusResult, PartnerInviteStatus } from "#/components/partner-access/partnerAccessTypes"
import { validatePartnerDOB } from "#/services/common-forms"
import { dayjs } from "@carrotfertility/carotene-core"

export function PartnerDateOfBirth({
  inviteData = null,
  hasAnyPartnerInfo = false,
  disabled = false
}: {
  inviteData?: InviteStatusResult
  hasAnyPartnerInfo?: boolean
  disabled?: boolean
}): JSX.Element {
  const intl = useIntl()

  function validate(dateOfBirthValue: dayjs.Dayjs): string | boolean {
    try {
      dateOfBirthValue?.toISOString()
    } catch (e) {
      return intl.formatMessage({ defaultMessage: "Please enter a valid date" })
    }

    if (inviteData && inviteData?.status !== PartnerInviteStatus.NONE && hasAnyPartnerInfo && !dateOfBirthValue) {
      return intl.formatMessage({ defaultMessage: "Required" })
    }

    if (hasAnyPartnerInfo && !dateOfBirthValue) {
      return intl.formatMessage({ defaultMessage: "Required" })
    }

    if (!dateOfBirthValue) return true

    const result = validatePartnerDOB(dateOfBirthValue)
    if (typeof result !== "boolean") {
      return intl.formatMessage(result)
    }
    return result
  }

  return (
    <FormDatePicker
      required={hasAnyPartnerInfo || (inviteData && inviteData?.status !== PartnerInviteStatus.NONE)}
      controllerProps={{ rules: { validate } }}
      name="partnerDateOfBirth"
      label={intl.formatMessage({ defaultMessage: "Date of birth" })}
      disabled={disabled}
    />
  )
}
